export default __webpack_public_path__ + "static/media/quoth_logo.7136057d.png";